import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import hitStatusBulkStore, { hitStatusBulkStoreState } from './hit-status-bulk-store/hit-status-bulk-store.store';
import { HitStatus } from './hit-status.interface';
import { HitStatusService } from './hit-status.service';
const service = new HitStatusService();

export interface HitStatusState {
   hitStatusBulkStore?: hitStatusBulkStoreState;
}

const HitStatusStore: Module<HitStatusState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async changeHitStatus(context, payload: { hitId: number; hitStatus: HitStatus }) {
         const { hitId, hitStatus } = payload;
         const response = await service.putHitStatus(hitId, hitStatus);
         return response.data;
      },
      async postHitStatus(context, payload: { hitId: number; hitStatus: HitStatus }) {
         const { hitId, hitStatus } = payload;
         const response = await service.postHitStatus(hitId, hitStatus);
         return response.data;
      },
   },
   modules: {
      hitStatusBulkStore,
   },
};

export default HitStatusStore;
